import { render, staticRenderFns } from "./TaskSmallCard.vue?vue&type=template&id=a0854e24&scoped=true"
import script from "./TaskSmallCard.vue?vue&type=script&lang=js"
export * from "./TaskSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0854e24",
  null
  
)

export default component.exports